// Generated by scripts/build-ui-icons.mjs.
export { Phone as default } from "../ui/glyphs-6";
